import {
  AccountsSortOptions,
  isChildAccount,
  isOrgAccount,
  useCloudAccounts,
  useCloudsResources
} from 'features/clouds'
import { getResourceName, getRsrcError } from 'features/resources'
import { CloudCard, TargetIcon, Typography } from 'procyon-ui'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { useClouds } from '../../Clouds.utils'
import { useAWSAccounts } from './AWSAccounts.utils'
import { ErrorModal } from 'features/policy'
import { getHTMLDataTestID } from 'infra/utils'

export default function AWSAccounts({ searchKey }) {
  const [activeOption, setActiveOption] = useState('all')
  const [errorMessage, setErrorMessage] = useState({ message: '', url: '' })

  const history = useHistory()

  const { cloudType } = useClouds()
  const { getAccountTargets } = useCloudsResources()
  const { getParentAccount } = useCloudAccounts()
  const { sortOptions, filteredAccounts } = useAWSAccounts({ searchKey, sortOption: activeOption })

  return (
    <div>
      <div className='flex justify-between'>
        <Typography style={{ color: 'var(--color-font-base)' }} variant='body-regular'>
          {filteredAccounts.length} Accounts
        </Typography>
      </div>
      <div className='grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-8 mt-4'>
        {filteredAccounts.map((a) => {
          const { _meta } = getAccountTargets(a)
          const isChild = isChildAccount(a)
          const isOrg = isOrgAccount(a)
          const parentAccount = getParentAccount(a)
          const namespace = a.ObjectMeta.Namespace

          const error = getRsrcError(a)
          const url = `/admin/clouds/${cloudType.toLowerCase()}/${encodeURIComponent(
            a.ObjectMeta.Name
          )}`

          return (
            <CloudCard
              rootProps={{
                'data-testid': getHTMLDataTestID('clouds-aws', 'div', 'card', a.ObjectMeta.Name)
              }}
              width='100%'
              // @ts-ignore
              caption={
                isOrg ? (
                  'Org Account'
                ) : isChild ? (
                  <>
                    Child of <strong className='ml-1'>{getResourceName(parentAccount)}</strong>
                  </>
                ) : (
                  ''
                )
              }
              icon={
                <TargetIcon
                  height='100%'
                  type={isOrg ? 'AWS_ORG' : isChild ? 'AWS_CHILD' : 'AWS_APPLICATION'}
                  width='100%'
                />
              }
              menuItems={[]}
              showResourcesButton={!isOrg}
              name={getResourceName(a)}
              onClickMoreInfo={() => history.push(url)}
              onClickResources={function noRefCheck() {}}
              resourcesAmount={_meta.count}
              showErrorButton={!!errorMessage.message}
              onErrorClick={() =>
                setErrorMessage({
                  message: error,
                  url
                })
              }
            />
          )
        })}
      </div>
      {errorMessage.message && (
        <ErrorModal
          message={errorMessage.message}
          onClose={() => setErrorMessage({ message: '', url: '' })}
          showModal
          title='Account Error'
          onViewDetailsClick={() => history.push(errorMessage.url)}
        />
      )}
    </div>
  )
}
